import React, { useCallback } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { SmartlistType } from "../../api/MediaAPI.types";
import CreateButton from "../common/CreateButton";
import GenericSmartlistList from "../common/smartlist/GenericSmartlistList";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

function SmartlistAudioList(): JSX.Element {
  const { t } = useTranslation("editor-smartlist");
  const getDeleteBody = useCallback(
    (label: string): string => t("deleteBody", { smartlist: label }),
    [t],
  );
  const { projectSlug } = useParams<{ projectSlug: string }>();

  const breadcrumbs = [
    {
      name: t("editor-menu:publishing-management"),
      url: "/smartlist_audio",
    },
    {
      name: t("sectionTitleAudio"),
    },
  ];

  const createButton = (
    <CreateButton
      href={`${PROJECTS_ROUTE}/${projectSlug}/smartlist_audio/new/`}
      label={t("createSmartlistAudio")}
    />
  );

  return (
    <GenericSmartlistList
      breadcrumbs={breadcrumbs}
      createButton={createButton}
      deleteCompleteText={t("deleteComplete")}
      deleteTitle={t("deleteTitle")}
      editUrlPrefix="smartlist_audio"
      getDeleteBody={getDeleteBody}
      smartlistTypes={SmartlistType.AUDIO}
      tableTitle={t("sectionTitleAudio")}
    />
  );
}

export default SmartlistAudioList;
